import { Action } from "@globalState/actions/action";
import { GlobalState } from "@globalState/initialState";
import { mainReducer } from "@globalState/reducers/mainReducer";

export const rootReducer = ({ main }: GlobalState, action: Action): GlobalState => ({
    main: mainReducer(main, action)
});
